import { Mail, MessageSquare, Bug } from "lucide-react";
import { Section } from "@/layouts/Section";

const CONTACT_REASONS = [
  {
    icon: MessageSquare,
    title: "General questions",
    desc: "Questions about how the platform works, what's included in each plan, or how to get started.",
  },
  {
    icon: Bug,
    title: "Bug reports",
    desc: "Found something that doesn't work as expected? Let us know and we'll look into it.",
  },
  {
    icon: Mail,
    title: "Feature requests",
    desc: "Have an idea for something that would make your reporting workflow easier? We're listening.",
  },
];

export default function Contact() {
  return (
    <div className="contact-page">

      {/* ── Header ──────────────────────────────────────────────── */}
      <Section variant="light">
        <div className="max-w-[560px] mx-auto flex flex-col gap-4">
          <div className="section-label">Get in touch</div>
          <h1 className="section-heading mb-4">
            We read every message.
          </h1>
          <p className="text-[1.0625rem] leading-[1.65] text-muted-foreground m-0">
            Questions, bug reports, feedback - send them all to the same place.
            You&apos;ll hear back from a real person, not a bot.
          </p>
          <a href="mailto:contact@easyreports.ca" className="inline-flex items-center gap-2 text-[1.125rem] font-semibold text-brand-700 no-underline border-b-2 border-brand-700/25 pb-[2px] w-fit transition-colors hover:text-brand-800 hover:border-brand-700">
            <Mail size={18} />
            contact (at) easyreports (dot) ca
          </a>
        </div>
      </Section>

      {/* ── Reasons ─────────────────────────────────────────────── */}
      <Section variant="muted">
        <div className="max-w-[1100px] mx-auto">
          <div className="section-label">What to write about</div>
          <h2 className="section-heading">Reach out for any of the following.</h2>
          <div className="grid grid-cols-3 gap-8 max-[720px]:grid-cols-1 max-[720px]:gap-6">
            {CONTACT_REASONS.map((r) => (
              <div key={r.title} className="bg-card border border-border rounded-[14px] p-7">
                <div className="w-10 h-10 rounded-[10px] bg-brand-700/10 text-brand-600 dark:bg-brand-400/15 dark:text-brand-300 flex items-center justify-center mb-4">
                  <r.icon size={20} />
                </div>
                <h3 className="text-[1.0625rem] font-semibold text-foreground m-0 mb-2">{r.title}</h3>
                <p className="text-[0.9rem] leading-relaxed text-muted-foreground m-0">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* ── Response note ───────────────────────────────────────── */}
      <Section variant="light">
        <div className="max-w-[560px] mx-auto">
          <div className="bg-muted border border-border rounded-2xl p-8 flex flex-col gap-4">
            <span className="section-label mb-0">Response time</span>
            <p className="text-base leading-[1.65] text-muted-foreground m-0">
              We typically respond within one business day. During busy reporting
              periods (November and March) it may take a little longer - we
              appreciate your patience.
            </p>
          </div>
        </div>
      </Section>

    </div>
  );
}
